<div>
  <h3>{{ 'property.about_property' | translate }}</h3>
  <app-property-image-gallery [imagesList]="imagesList" size="small"></app-property-image-gallery>
  <div class="ion-text-center">
    <ion-button [routerLink]="['/p', parentId]"
                [queryParams]="{c: propertyInfo?.subCatName.nameEn, t: propertyInfo?.urlFriendlyTitle}"
                color="dark" fill="outline">{{ 'property.learn_more' | translate }}</ion-button>
  </div>
</div>
